import HomeOutlineFive from '@assets/icons/home-outline-five.svg'
import { Icon } from './Icon'

export const HomeOutlineFiveIcon = Icon(HomeOutlineFive)
